module.exports = __webpack_public_path__ + "img/jianzhu_anquan.921d945f.png";